import './TQUnlockPromptScreen.scss';

import React, { memo } from 'react';

import {
  Button,
  Typography,
} from 'antd';

import { useAppSelector } from '../../../shared/hooks';
import { dynamicItemTitle } from '../../../shared/utils';

const TQUnlockPromptScreen: React.FC = () => {
  const { hostMetadata } = useAppSelector((state) => state.app);

  const platformLogo = hostMetadata?.logo;
  const appName = hostMetadata?.appName || 'Platform';
  const unlockPromptSettings =
    hostMetadata?.tqConnectConfig?.unlockPromptSettings;

  // Default values if not configured
  const title =
    unlockPromptSettings?.title ||
    `${dynamicItemTitle('tq-title', 'default')} is for Premium Members`;
  const subtitle =
    unlockPromptSettings?.subtitle || 'Learn how you can unlock this feature';
  const ctaButtonText = unlockPromptSettings?.ctaButtonText || 'Learn More';
  const ctaButtonUrl = unlockPromptSettings?.ctaButtonUrl;

  const handleCtaClick = () => {
    if (ctaButtonUrl) {
      window.open(ctaButtonUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="tq-unlock-prompt-screen">
      <div className="unlock-prompt__content">
        <div className="unlock-prompt__logo">
          {platformLogo ? (
            <img
              src={platformLogo}
              alt={appName}
              className="unlock-prompt__logo-img"
            />
          ) : (
            <div className="unlock-prompt__logo-placeholder">
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="3"
                  y="3"
                  width="18"
                  height="18"
                  rx="4"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <circle
                  cx="12"
                  cy="10"
                  r="3"
                  stroke="currentColor"
                  strokeWidth="2"
                />
                <path
                  d="M6 19C6 16.2386 8.68629 14 12 14C15.3137 14 18 16.2386 18 19"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          )}
        </div>

        <Typography.Title level={3} className="unlock-prompt__title">
          {title}
        </Typography.Title>

        <Typography.Paragraph className="unlock-prompt__subtitle">
          {subtitle}
        </Typography.Paragraph>

        {ctaButtonUrl && (
          <Button
            type="primary"
            size="large"
            className="unlock-prompt__cta-button"
            onClick={handleCtaClick}>
            {ctaButtonText}
          </Button>
        )}
      </div>
    </div>
  );
};

export default memo(TQUnlockPromptScreen);
